module.exports = __webpack_public_path__ + "img/cdrcfwm_code.cc1a16f3.png";